var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass:
        "order-return-review-customer-details flex flex-auto flex-col",
    },
    [
      _c("div", { staticClass: "title" }, [
        _vm._v("\n    Review customer details and address\n  "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "description" }, [
        _vm._v(
          "\n    Review the customer details before submitting a request.\n  "
        ),
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "return-customer-details" },
        [
          _c(
            "el-card",
            { attrs: { shadow: "never" } },
            [
              _c("div", { staticClass: "flex flex-col" }, [
                _c("div", { staticClass: "summary-header" }, [
                  _vm._v("\n          Old Product\n        "),
                ]),
                _vm._v(" "),
                _c("div", { staticStyle: { "margin-top": "8px" } }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.device.profile.product.description)
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticStyle: { color: "#6E6E6E", margin: "0 !important" },
                    },
                    [
                      _vm._v(
                        "\n            MAC ID: " +
                          _vm._s(_vm.device.mac_address) +
                          "\n          "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.device.profile && _vm.device.profile.color
                    ? _c(
                        "p",
                        {
                          staticStyle: {
                            color: "#6E6E6E",
                            margin: "0 !important",
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.device.profile.color) +
                              "\n          "
                          ),
                        ]
                      )
                    : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _c("el-divider"),
              _vm._v(" "),
              _c("div", { staticClass: "flex flex-col" }, [
                _c("div", { staticClass: "summary-header" }, [
                  _vm._v("\n          Replacement Product\n        "),
                ]),
                _vm._v(" "),
                _c("div", { staticStyle: { "margin-top": "8px" } }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.replacementProduct.product.description)
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticStyle: { color: "#6E6E6E", margin: "0 !important" },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.replacementProduct.color) +
                          "\n          "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.replacementProduct.estimated_delivery
                    ? _c(
                        "p",
                        {
                          staticClass: "estimated-delivery",
                          staticStyle: { margin: "0 !important" },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.replacementProduct.estimated_delivery
                              ) +
                              "\n          "
                          ),
                        ]
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _vm.replacementProduct.out_of_stock
                  ? _c(
                      "div",
                      { staticClass: "flex flex-col" },
                      [
                        _c(
                          "el-alert",
                          {
                            attrs: {
                              title: "This product is out of stock.",
                              type: "error",
                              "show-icon": "",
                            },
                          },
                          [
                            _c(
                              "span",
                              [
                                _vm._v(
                                  "Estimated back stock date is\n              "
                                ),
                                _c("time-zone-formatter", {
                                  attrs: {
                                    "current-time":
                                      _vm.replacementProduct.restock_dt,
                                  },
                                }),
                                _vm._v(".\n            "),
                              ],
                              1
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("el-alert", {
                          attrs: {
                            type: "warning",
                            description:
                              "Ring Neighbors will be sent an equal or better device depending on stock availability of the device requested.",
                            "show-icon": "",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("el-divider"),
              _vm._v(" "),
              _c("div", { staticClass: "flex flex-col" }, [
                _c("div", { staticClass: "summary-header" }, [
                  _vm._v("\n          Replacement Reason\n        "),
                ]),
                _vm._v(" "),
                _c("div", { staticStyle: { "margin-top": "8px" } }, [
                  _vm._v("\n          " + _vm._s(_vm.selectedName)),
                  _c("br"),
                ]),
              ]),
              _vm._v(" "),
              _c("el-divider"),
              _vm._v(" "),
              _c("div", { staticClass: "flex flex-col" }, [
                _c("div", { staticClass: "summary-header" }, [
                  _vm._v("\n          Other Info\n        "),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "flex flex-row",
                    staticStyle: { "margin-top": "8px" },
                  },
                  [
                    _c("div", { staticClass: "flex-1" }, [
                      _vm._v("\n            Place of purchase\n          "),
                    ]),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(_vm.retailer))]),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "flex flex-row" }, [
                  _c("div", { staticClass: "flex-1" }, [
                    _vm._v("\n            Date of initial setup\n          "),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c("time-zone-formatter", {
                        attrs: {
                          "output-format": "DD MMMM, YYYY",
                          "current-time": _vm.firstSetupDate,
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("el-divider"),
              _vm._v(" "),
              _c("div", { staticClass: "flex flex-col" }, [
                _c("div", { staticClass: "summary-header" }, [
                  _vm._v("\n          Customer info\n        "),
                ]),
                _c("br"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flex flex-col" }, [
                _c("div", { staticClass: "flex flex-row" }, [
                  _c("div", { staticClass: "flex-1" }, [
                    _vm._v("\n            Name\n          "),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      _vm._s(_vm.customer.first_name) +
                        " " +
                        _vm._s(_vm.customer.last_name)
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "flex flex-row" }, [
                  _c("div", { staticClass: "flex-1" }, [
                    _vm._v("\n            Phone Number\n          "),
                  ]),
                  _vm._v(" "),
                  _c("div", [_vm._v(_vm._s(_vm.customer.phone_number))]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "flex flex-row" }, [
                  _c("div", { staticClass: "flex-1" }, [
                    _vm._v("\n            Email\n          "),
                  ]),
                  _vm._v(" "),
                  _c("div", [_vm._v(_vm._s(_vm.customer.email))]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "flex flex-row",
                    staticStyle: { "margin-top": "20px" },
                  },
                  [
                    _c("div", { staticClass: "flex-1" }, [
                      _vm._v("\n            Street\n          "),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        _vm._s(_vm.address.address1) +
                          " " +
                          _vm._s(_vm.address.address2)
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "flex flex-row" }, [
                  _c("div", { staticClass: "flex-1" }, [
                    _vm._v("\n            City\n          "),
                  ]),
                  _vm._v(" "),
                  _c("div", [_vm._v(_vm._s(_vm.address.city))]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "flex flex-row" }, [
                  _c("div", { staticClass: "flex-1" }, [
                    _vm._v("\n            State/province/area\n          "),
                  ]),
                  _vm._v(" "),
                  _c("div", [_vm._v(_vm._s(_vm.address.state))]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "flex flex-row" }, [
                  _c("div", { staticClass: "flex-1" }, [
                    _vm._v("\n            Zip code\n          "),
                  ]),
                  _vm._v(" "),
                  _c("div", [_vm._v(_vm._s(_vm.address.zip_code))]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "flex flex-row" }, [
                  _c("div", { staticClass: "flex-1" }, [
                    _vm._v("\n            Country\n          "),
                  ]),
                  _vm._v(" "),
                  _c("div", [_vm._v(_vm._s(_vm.address.country))]),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { "margin-top": "24px" } }, [
      _c("div", { staticClass: "section-header" }, [
        _c("div", { staticClass: "flex-1" }, [
          _vm._v("\n        Replacement Summary\n      "),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }